// import store from '@/core/config.store';
import store from '@/core/config.store';
import axios from 'axios';
import qs from 'qs';

/**
 * @description:  contentType
 */
export const ContentTypeEnum = {
  // json
  JSON: 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED: 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA: 'multipart/form-data;charset=UTF-8'
};
/**
 * @description:  contentType
 */
export const ContentFormatTypeEnum = {
  // json
  JSON: 'json',
  // form-data qs
  FORM_URLENCODED: 'form-urlencoded',
  // form-data  upload
  FORM_DATA: 'form-data'
};
const defaultConfig = {
  baseURL: '/',
  timeout: 30000,
  method: 'get',
  format: ContentFormatTypeEnum.JSON
};

export function Http(config) {
  this.config = Object.assign({}, defaultConfig, config);
  this.$axios = this.create();
}

Http.prototype._request = function(url, data, config, method = 'get') {
  Object.assign(config, { data, url, method, baseURL: store.getters.mall.domain || this.config.baseURL });
  return this.request(config);
};
Http.prototype.get = function(url, config = {}) {
  return this._request(url, null, config, 'get');
};
Http.prototype.post = function(url, data, config = {}) {
  return this._request(url, data, config, 'post');
};
Http.prototype.patch = function(url, data, config = {}) {
  return this._request(url, data, config, 'patch');
};
Http.prototype.put = function(url, data, config = {}) {
  return this._request(url, data, config, 'put');
};
Http.prototype.delete = function(url, config) {
  return this._request(url, null, config, 'delete');
};

Http.prototype.request = async function(opts) {
  console.log('opts', opts);
  // 默认参数
  opts = Object.assign({ method: this.config.method, format: this.config.format, headers: {} }, opts);

  // 处理token
  if (opts.token !== false) {
    const isOk = await this.config.tokenConfig?.checkToken();
    if (isOk) {
      opts.headers[this.config.tokenConfig?.key || 'Authorization'] ||= this.config.tokenConfig?.get();
    }
  }

  // 格式化url参数
  if (opts.params && opts.url && /{.+}/.test(opts.url)) {
    for (const i in opts.params) {
      const originUrl = opts.url;
      opts.url = opts.url?.replace(`{${i}}`, opts.params[i]);
      if (originUrl !== opts.url) {
        delete opts.params[i];
      }
    }
  }

  opts.method = opts.method.toLocaleLowerCase();
  // 处理post/put/patch请求体
  if (['post', 'put', 'patch'].includes(opts.method)) {
    switch (opts.format) {
      case ContentFormatTypeEnum.JSON:
        opts.headers['Content-Type'] = ContentTypeEnum.JSON;
        break;
      case ContentFormatTypeEnum.FORM_URLENCODED:
        opts.headers['Content-Type'] = ContentTypeEnum.FORM_URLENCODED;
        opts.data = qs.stringify(opts.data);
        break;
      case ContentFormatTypeEnum.FORM_DATA:
        opts.headers['Content-Type'] = ContentTypeEnum.FORM_DATA;
        // eslint-disable-next-line no-case-declarations
        const formData = new FormData();
        for (const key in opts.data) {
          if (Object.prototype.hasOwnProperty.call(opts.data, key)) {
            const v = opts.data[key];
            formData.append(key, v);
          }
        }
        opts.data = formData;
        break;
      default:
        break;
    }
  }

  return this.$axios.request(opts);
};

Http.prototype.create = function(config) {
  const { interceptor, ...rest } = config || this.config;
  const instance = axios.create(rest);

  interceptor?.request && instance.interceptors.request.use(interceptor.request, (error) => Promise.reject(error));

  interceptor?.response && instance.interceptors.response.use(interceptor.response, interceptor?.error);

  return instance;
};
